/**
 * localStorage utility functions with type safety
 */

/**
 * Get item from localStorage with JSON parsing
 */
export function getItem<T>(key: string): T | null {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch {
    return null;
  }
}

/**
 * Set item in localStorage with JSON stringification
 */
export function setItem<T>(key: string, value: T): void {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(`Failed to save to localStorage: ${key}`, error);
  }
}

/**
 * Remove item from localStorage
 */
export function removeItem(key: string): void {
  localStorage.removeItem(key);
}

/**
 * Get raw string from localStorage
 */
export function getRaw(key: string): string | null {
  return localStorage.getItem(key);
}

/**
 * Set raw string to localStorage
 */
export function setRaw(key: string, value: string): void {
  localStorage.setItem(key, value);
}
